import type React from 'react';

import { ProfileCard } from './ProfileCard';

export const ProfileCardWrapper: React.FC = () => {
	return (
		<div className="mb-16 px-4 md:px-0">
			<ProfileCard />
		</div>
	);
};
